import { Typography, TypographyProps } from "@mui/material"
import { KojinResult } from "interface/kojin"

type MrpStatsProps = {
	stats: KojinResult['mrpStats']
} & TypographyProps
export const MrpStats = ({
	stats,
	...others
}: MrpStatsProps) => stats?.rank ? (
	<Typography variant="caption" color="text.primary" component="div" {...others}>
		{stats.rank.name}
	</Typography>
) : <></>
